module.exports = __webpack_public_path__ + "static/img23-9b0f77fcc1dc40740c382c339ba28955.jpg";